import { SERVER } from "../constants";
import { MAP_URL } from "../constants/urls";
import { HttpClient, SaveImage, SaveFile } from "../utils/requests";
import { fixUpdateProductCategoryId } from "../panels/productCategory/productCategoryMapper";
import { fixUpdateProductId } from "../panels/product/productMapper";
import { fixUpdateBranchId } from "../panels/branch/branchMapper";
import { fixUpdateNeedId } from "../panels/needs/needMapper";
import { fixUpdateNeedCategoryId } from "../panels/needCategory/needCategoryMapper";
import { fixUpdateUnitId } from "../panels/essentials/unit/unitMapper";
import { fixUpdateId } from "../panels/essentials/unitProcessor/unitProcessorMapper";
import { fixUpdateStatusId } from "../panels/essentials/status/statusMapper";
import { fixUpdateStatusLoadingId } from "../panels/essentials/statusLoading/statusLoadingMapper";

import { fixUpdateReportId } from "../panels/report/reportMapper";
import { fixUpdateLoadingRequestId } from "../panels/loadingRequest/loadingRequestMapper";
import { fixUpdateWhatsapptId } from "../panels/whatsapp/whatsappMapper";
import { fixUpdateCustomerId } from "../panels/crm/customer/customerMapper";
import { fixUpdatePreferCallId } from "../panels/essentials/preferCall/preferCallMapper";
import { fixUpdateStatusCallId } from "../panels/essentials/statusCall/statusCallMapper";
import { fixUpdatePackageId } from "../panels/essentials/package/packageMapper";
import { fixUpdateOrderTypeId } from "../panels/essentials/orderType/orderTypeMapper";
import { fixUpdateContactId } from "../panels/crm/contact/contactMapper";
import { fixUpdateCustomerCategoryId } from "../panels/crm/essentials/customerCategory/customerCategoryMapper";
import { fixUpdateContactCategoryId } from "../panels/crm/essentials/contactCategory/contactCategoryMapper";
import { fixUpdateCustomerRatingId } from "../panels/crm/essentials/customerRating/customerRatingMapper";
import { fixUpdateCustomerPriorityId } from "../panels/crm/essentials/customerPriority/customerPriorityMapper";
import { fixUpdateStorageId } from "../panels/essentials/storage/storageMapper";
import { fixUpdateClueId } from "../panels/crm/clue/clueMapper";
import { fixUpdateReminderId } from "../panels/crm/reminder/reminderMapper";
import { fixUpdateSendSMSId } from "../panels/essentials/sms/SendSMSMapper";
import { fixUpdateTransactionId } from "../panels/transaction/transactionMapper";
import { fixUpdateRawMaterialId } from "../panels/product/details/rawMaterial/rawMaterialMapper";
import { fixUpdateProductUnitId } from "../panels/product/details/productUnit/productUnitMapper";
import { fixUpdateBaseUnitId } from "../panels/product/details/baseUnit/baseUnitMapper";
import { fixUpdateProductCapacityId } from "../panels/productCapacity/productCapacityMapper";
import { fixUpdateEventPanelId } from "../panels/event/eventMapper";
import { fixUpdateReportInputProductId } from "../panels/reportInputProducts/reportInputProductsMapper";
import { fixUpdateReportProductionId } from "../panels/reportProduction/reportProductionMapper";

export async function update(resource, params) {
  if (params.data.pictures) {
    await SaveImage(resource, params);
  }
  if (params.data.attachfile) {
    await SaveFile(resource, params);
  }
  let url = `${SERVER}/${MAP_URL[resource]}`;
  if (['adminUsers', 'config', 'user'].includes(resource)) {
    url = url + `/${params.id}`;
  }
  if (resource === 'productCategory') {
    let x = { ...params.data, categoryId: params.data.objectId };
    params.data = x;
  }
  return HttpClient(url, {
    method: "PUT",
    body: JSON.stringify(params.data),
  }).then(({ json }) => {
    if (resource === 'productCategory') {
      return fixUpdateProductCategoryId(json);
    } else if (resource === 'product') {
      return fixUpdateProductId(json);
    } else if (resource === 'branch') {
      return fixUpdateBranchId(json);
    } else if (resource === 'need') {
      return fixUpdateNeedId(json);
    } else if (resource === 'needCategory') {
      return fixUpdateNeedCategoryId(json);
    } else if (resource === 'unit') {
      return fixUpdateUnitId(json);
    } else if (resource === 'unitProcessor') {
      return fixUpdateId(json);
    } else if (resource === 'status') {
      return fixUpdateStatusId(json);
    } else if (resource === 'statusCall') {
      return fixUpdateStatusCallId(json);
    } else if (resource === 'preferCall') {
      return fixUpdatePreferCallId(json);
    } else if (resource === 'statusLoading') {
      return fixUpdateStatusLoadingId(json);
    } else if (resource === 'report') {
      return fixUpdateReportId(json);
    } else if (resource === 'reportProduction') {
      return fixUpdateReportProductionId(json);
    } else if (resource === 'reportInputProduct') {
      return fixUpdateReportInputProductId(json);
    } else if (resource === 'loadingRequest') {
      return fixUpdateLoadingRequestId(json);
    } else if (resource === 'whatsapp') {
      return fixUpdateWhatsapptId(json);
    } else if (resource === 'customer') {
      return fixUpdateCustomerId(json);
    } else if (resource === 'contact') {
      return fixUpdateContactId(json);
    } else if (resource === 'package') {
      return fixUpdatePackageId(json);
    } else if (resource === 'orderType') {
      return fixUpdateOrderTypeId(json);
    } else if (resource === 'customerCategory') {
      return fixUpdateCustomerCategoryId(json);
    } else if (resource === 'contactCategory') {
      return fixUpdateContactCategoryId(json);
    } else if (resource === 'customerPriority') {
      return fixUpdateCustomerPriorityId(json);
    } else if (resource === 'customerRating') {
      return fixUpdateCustomerRatingId(json);
    } else if (resource === 'storage') {
      return fixUpdateStorageId(json);
    } else if (resource === 'clue') {
      return fixUpdateClueId(json);
    } else if (resource === 'reminder') {
      return fixUpdateReminderId(json);
    } else if (resource === 'sendSMS') {
      return fixUpdateSendSMSId(json);
    } else if (resource === 'transaction') {
      return fixUpdateTransactionId(json);
    } else if (resource === 'baseUnit') {
      return fixUpdateBaseUnitId(json);
    } else if (resource === 'productUnit') {
      return fixUpdateProductUnitId(json);
    } else if (resource === 'rawMaterial') {
      return fixUpdateRawMaterialId(json);
    } else if (resource === 'productCapacity') {
      return fixUpdateProductCapacityId(json);
    } else if (resource === 'eventPanel') {
      return fixUpdateEventPanelId(json);


    }

    return {
      data: { ...json, id: json.phoneNumber },
    };
  }
  );
}